import { render } from "./CompetitionCard.vue?vue&type=template&id=3e6c7795"
import script from "./CompetitionCard.vue?vue&type=script&lang=js"
export * from "./CompetitionCard.vue?vue&type=script&lang=js"

import "./CompetitionCard.vue?vue&type=style&index=0&id=3e6c7795&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__